import '../css/AddNursing.css'

import { Fragment, useEffect, useState } from "react"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 10 }
}

interface Prop {
    clientData?: Client
    onChange?: () => void
}

interface Client {
    id: string // 客户标识
    deal_id: string // 签单标识
    deal_item_name: string // 签单套餐名称
    nursing_care_type_desc: string // 护理模式
    hospital_escort_days: number // 医院陪护天数
    customer_name: string // 姓名
    customer_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期
    service_status: number  // 服务状态，0待分配 1待上户 2已上单 3已下单
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
    service_left_days: number // 剩余天数
    service_address: string // 服务地址
}

export default function (prop: Prop) {

    const [employeeList, setEmployeeList] = useState<any[]>([])

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    useEffect(() => {
        baseAxiosNoInfo('/yuesao_center/global/archives_list', {

        }).then((res: any) => {
            if (res) {
                setEmployeeList(res)
            }
        })
    }, [])

    // 提交
    const onFinish = () => {
        if (!form.getFieldValue('service_start_date') || !form.getFieldValue('service_days')) {
            message.error('请选择服务信息才能提交')
            return
        }

        if (!form.getFieldValue('belong_nursing_id')) {
            message.error('请选择护理师才能提交')
            return
        }

        baseAxiosComplete.post('/yuesao_center/customer/residence/distribute_nursing', {
            deal_id: prop.clientData?.deal_id,
            belong_nursing_id: form.getFieldValue('belong_nursing_id'),
            service_start_date: form.getFieldValue('service_start_date') ? form.getFieldValue('service_start_date').format('YYYY-MM-DD HH:mm:ss') : '',
            service_days: form.getFieldValue('service_days')
        }).then((res: any) => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 到府客户管理 -> 客户详情 -> 分配护理师 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>分配护理师</Button>

        <Modal zIndex={1} title="分配护理师" width={550} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={10}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{prop.clientData && prop.clientData?.customer_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{prop.clientData && prop.clientData?.customer_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{prop.clientData && prop.clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期：</p>
                            <p>{prop.clientData && prop.clientData?.expect_born_day || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={10}>
                    <div>
                        <Space>
                            <p>服务开始日期：</p>
                            <p>{prop.clientData && prop.clientData?.service_start_date}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>服务结束日期：</p>
                            <p>{prop.clientData && prop.clientData?.service_end_date}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>服务天数：</p>
                            <p>{prop.clientData && prop.clientData?.service_days}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={20}>
                    <Form form={form} {...formItemLayout} style={{ marginTop: 20 }} >
                        <Form.Item required name="service_start_date" label="开始日期" >
                            <DatePicker showTime />
                        </Form.Item>

                        <Form.Item required name="service_days" label="护理天数">
                            <Input placeholder="请输入天数" />
                        </Form.Item>

                        <Form.Item required name="belong_nursing_id" label="护理师">
                            <Select >
                                {employeeList.map((el: any) => (<Option value={el.id} key={el.id} >{el.user_name}</Option>))}
                            </Select>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Modal>
    </Fragment>
}